/**
 * 企業中心 PC 首頁 — 繁體中文（嵌套結構，對應 t('corporateCenter.indexPc.…')）
 */
export default {
	banner: {
		titleLine1: "為機構流量賦能",
		titleLine2: "合規護航 增效拓客",

		body: "先知命局集團公司總部位於香港，分公司輻射新加坡、馬來西亞、台灣。平台本身主打全球領先的人生導師數位交易市場，依託 AI 與數位化技術構建交易平台，連接有人生抉擇困惑、需隱私化專業幫助的用戶與全球優質服務機構，通過評價體系、擔保服務、標準化流程及高效運營工具，保障雙方權益，陪伴用戶實現自我成長，最終達成讓生活更輕鬆「See Beyond」的核心願景。",
		joinCta: "立即入駐",
		contactCta: "聯絡我們",
		heroImageAlt: "先知命局企業服務介紹",
		contactCoopModal: {
			title: "歡迎合作",
			body: "我們聚焦的「全球導師+隱私保護+數字化服務」賽道，具備廣闊的增長空間，歡迎加入合作。",
			cta: "聯繫我們（{email}）→",
			closeAria: "關閉",
		},
	},
	section1: {
		sectionTitle: "守護百年基業，迎接新世代的挑戰",
		challengeColumnTitle: "關鍵挑戰",
		solutionColumnTitle: "一站式數位化解決方案",
		challenge: [
			{
				title: "年輕人斷層",
				desc: "現代人生活步調緊湊，對傳統信仰容易產生疏離感與距離感。",
			},
			{
				title: "遠距代辦顧慮",
				desc: "線上匯款祈福後，無法親眼見證執行過程，難免對儀式是否確實辦理心存疑慮。",
			},
			{
				title: "各機構行政事務繁重",
				desc: "名單登記、帳務核對、開立收據等事務，耗費大量人力與時間。",
			},
		],
		solution: [
			{
				title: "精準引路：科技即神明之分身",
				desc: "透過手機測試引導年輕族群，精準導引有緣人歸廟祈福。",
			},
			{
				title: "神蹟顯現：非改變傳統，而是革新工具。",
				desc: "儀式全程錄影存證，一鍵回傳信眾，讓護佑真實可見、誠心有所回應。",
			},
			{
				title: "香火不斷：化身機構專屬「數位秘書」",
				desc: "依節氣自動提醒祈福，無距離限制，讓神佑時時相伴、香火綿延不絕。",
			},
		],
	},
	section2: {
		mapImageAlt: "全球分布地圖",
		sectionTitle: "為什麼選擇先知命局?",
		sectionDesc: "先知命局集團總部位於香港，分公司遍布新加坡、馬來西亞、台灣。",
		marker: [{ label: "北美" }, { label: "其他地區" }, { label: "東南亞" }, { label: "日韓" }],
		metric: [
			{ text: "每月 App 登入用戶數" },
			{ text: "每月活躍用戶" },
			{ text: "Facebook 追蹤數" },
			{ text: "YouTube 未重複閱聽眾" },
			{ text: "全球合作超過" },
		],
	},
	section3: {
		sectionTitle: "合作價值",
		rowLabelTop: "實際成效",
		rowLabelBottom: "長遠價值",
		top: [
			{
				title: "數位轉型機會",
				desc: "機構可憑藉先知命局的 AI 與數位化能力升級線上經營，享受 SaaS 工具與廣告推廣賦能，穩握數位轉型紅利，為用戶提供高品質服務。",
			},
			{
				title: "拓展業務渠道",
				desc: "整合線上線下服務場景，為道館、寺廟、教堂、冥想、療癒、心理諮詢等機構定制解決方案。助力機構開拓穩定客源、突破服務邊界，以精準用戶觸達拉動市場增長，擴充業務規模。",
			},
			{
				title: "提升機構影響力",
				desc: "依託平台流量與用戶基礎，提升機構品牌曝光與公信力，規範流程、降低風險、強化專業競爭力。實現雙向賦能、互利共贏，構建可持續生態，鞏固行業領先優勢。",
			},
		],
		bottom: [
			{
				title: "智慧白話文",
				desc: "將深奧傳統智慧轉為淺白易懂的現代指引，讓年輕人輕鬆理解、樂於接受。",
			},
			{
				title: "服務精品化",
				desc: "將宮廟服務升級為專屬心靈導航，吸引多元年輕白領群體。",
			},
			{
				title: "形象專業化",
				desc: "摒除江湖氣息，樹立專業權威形象，全面提升宮廟社會地位與公信力。",
			},
		],
	},
	join: {
		sectionTitle: "入駐流程",
		centerImageAlt: "先知命局",
		step1: {
			title: "入駐啟動",
			desc: "機構登入先知命局官網，\n開啟入駐流程",
		},
		step2: {
			title: "資料完善",
			desc: "填寫機構資料、裝飾展示頁面，\n上架服務並上傳資質",
		},
		step3: {
			title: "平台審核",
			desc: "平台對入駐申請開展\n資質與內容雙重審核",
		},
		step4: {
			title: "入駐成功",
			desc: "審核通過後，機構將接收通知，\n機構資料與服務同步上線至\n先知命局 App",
		},
	},
	section4: {
		title: "宣傳推廣・精準用戶觸達",
		desc: "機構審核通過後，用戶可在先知命局App 瀏覽機構資訊、選購所需服務；機構則可通過 App 免費諮詢功能與用戶對接，並完成服務交付。",
		imageAlt: "宣傳推廣展示",
	},
	section5: {
		title: "聯絡我們",
		desc: "機構入駐期間如遇任何問題，平台將由專屬客服團隊提供專業解答與全程支持。",
		btn: "立即聯絡專屬客服",
	},
	loginModal: {
		tabEmail: "電郵登入",
		tabPhone: "手機號登入",
		mPrivacy: "我們會保障您的隱私，其他人不會看到這項資料。",
		mPhoneStepTitle: "輸入您的手機號碼",
		mEmailStepTitle: "輸入您的電郵",
		mAreaCodeLabel: "區號",
		mSwitchToEmail: "使用電郵地址註冊/登入 >",
		mSwitchToPhone: "使用手機號註冊/登入 >",
		mNext: "下一步",
		mInvalidEmail: "請輸入有效的電子郵箱",
		mVerificationTitle: "輸入驗證碼",
		mVerificationSentPrefix: "我們已發送驗證碼至",
		mResendWait: "重新發送驗證碼 ({n}) 秒",
		mResendLink: "重新發送驗證碼",
		mToastCodeSent: "驗證碼已發送",
		mToastCodeSendFail: "發送驗證碼失敗，請重試",
		mToastLoginCodeWrong: "登入失敗，請檢查驗證碼是否正確",
		mToastSelectAreaCode: "請選擇區號",
		mToastCompleteCaptcha: "請先進行人機校驗",
		mToastCaptchaFail: "驗證失敗，請重試",
		mToastCaptchaExpired: "驗證已過期，請重新驗證",
		mToastCaptchaUnsupported: "當前瀏覽器不支持驗證，請使用其他瀏覽器",
		mPhonePlaceholder: "輸入您的手機號碼",
		mEmailPlaceholder: "請輸入電郵",
		mCodePlaceholderPhone: "請輸入手機驗證碼",
		mCodePlaceholderEmail: "請輸入電郵驗證碼",
		mGetCode: "獲取驗證碼",
		mLogin: "登入",
		mBack: "返回上一步",
		bindTitle: "請輸入電郵綁定賬號",
		bindDesc: "如有疑問，請聯繫客服",
		bindBtn: "綁定",
		kefu: "客戶支持",
		loginSuccess: "登入成功",
	},
};
